import { Toaster as SonnerToaster } from 'sonner';
import { useTheme } from '@/providers/ThemeProvider';

export function Toaster() {
  const { theme, isDark } = useTheme();

  return (
    <SonnerToaster
      theme={theme}
      position="top-right"
      richColors
      gap={8}
      toastOptions={{
        duration: 2000,
        style: {
          borderRadius: '10px',
          fontSize: '13px',
          padding: '14px 16px',
          boxShadow: isDark ? '0 8px 24px rgba(0,0,0,0.4)' : '0 4px 16px rgba(0,0,0,0.08)',
        },
      }}
    />
  );
}
